import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconClipboard2Sparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M17 4H21V15.0713L20.9473 15.0518L19.7734 12H16.2266L15.0518 15.0518L12 16.2266V19.7734L15.0518 20.9473L15.457 22H3V4H7V2H17V4ZM9 6H15V4H9V6Z" fill="currentColor"/><Path d="M19.4004 16.5996L22 17.5996V18.4004L19.4004 19.4004L18.4004 22H17.5996L16.5996 19.4004L14 18.4004V17.5996L16.5996 16.5996L17.5996 14H18.4004L19.4004 16.5996Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2Sparkle;
